<template>
  <div>

    <el-dialog id="cc" :center="true" :close-on-click-modal="false" :visible="showEdit"  @close="closeEditDialog" width="97%" style="margin-left: 10%;">
      <el-form :rules="rules" ref="order" :model="order" style="display: flex; flex-wrap: wrap;" :disabled="orderFormComponentsType === '详情'">

        <el-divider content-position="center">客资信息</el-divider>


        <el-form-item label="客资状态:"  style="width: 100%;"> {{ isCustomerStatus === 1 ? '定金客资' : isCustomerStatus === 2 ? '成单客资' : isCustomerStatus === 3 ? '退费客资' :  '' }}  </el-form-item>
        <el-form-item label="学生类型:"  style="width: 100%;"> {{ isClassType === 1  ? '规划' : isClassType === 2  ? '线下' : isClassType === 3 ? '纯补课' : '' }}  </el-form-item>
        <el-form-item label="客资状态:"  style="width: 100%;"> {{ customerReturnType === 1 ? '定金客资' : customerReturnType === 2 ? '成单客资'  :  '' }}  </el-form-item>

        <el-divider content-position="center">审批内容</el-divider>


        <div v-if="typeCustomerFunding === '定金'" style="width: 100%;" >


          <el-form-item label="学生类型">
            <el-input :clearable="false" v-model="isClassTypeTxts" autocomplete="off" size="small" ></el-input>
          </el-form-item>


          <el-form-item label="订单状态">
            <div>
              <el-select  v-model="OrderStatus" filterable  :clearable="false" style="width: 100%;" placeholder="请选择订单状态" @change="changeOrderStatus" size="small">
                <el-option v-for="item in optionOrderStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item  v-if="isClassType == 1" label="付款金额：">
            <el-input :clearable="false" v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"></el-input>
          </el-form-item>
          <el-form-item  v-if="isClassType == 1" label="收款时间：">
            <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
          </el-form-item>
          <el-form-item  v-if="isClassType == 1" label="收款渠道：">
            <el-select  filterable :clearable="false"  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
              <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  v-if="isClassType == 1" label="诊断课：">
            <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入诊断课"></el-input>
          </el-form-item>


          <el-form-item  v-if="isClassType == 3" label="付款金额：">
            <el-input :clearable="false" v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"></el-input>
          </el-form-item>
          <el-form-item  v-if="isClassType == 3" label="收款时间：">
            <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
          </el-form-item>
          <el-form-item  v-if="isClassType == 3" label="收款渠道：">
            <el-select  filterable :clearable="false"  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
              <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  v-if="isClassType == 3" label="学业课：">
            <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
          </el-form-item>

          <el-form-item  label="上传截图:">
              <div v-if="fileAllLists_DINGJIN.length > 0">
                <div v-for="(itme,index) in fileAllLists_DINGJIN" :key="index" style="margin-top: 10px;margin-left: 10px;">
                  <img style="width: 60%; height: 400px;" :src="itme.url" alt=""  v-if="itme.url">
                </div>
                <div style="width: 100%; text-align: center; margin-left: 120px;">
                  <el-button size="small" type="danger" class="btns" @click="handleUploadDelet('1')">删除</el-button>
                </div>
              </div>
          </el-form-item>
          

        </div>






        <div v-if="typeCustomerFunding === '成单'" style="width: 100%;">


              <el-form-item label="学生类型">
                <el-input :clearable="false" v-model="isClassTypeTxts" autocomplete="off" size="small" ></el-input>
              </el-form-item>

              <el-form-item label="是否收费" v-if="costType === 1 || costType === 2">
                <el-select  v-model="isThereACharge" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small">
                  <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="课程类型" v-if="isThereACharge === 1">
                <div>
                  <el-select  filterable :clearable="false"  v-model="isTypeLve" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择课程类别" :disabled="true">
                    <el-option v-for="item in payTypeLsit11" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </div>
              </el-form-item> 


              <el-form-item  v-if="costType === 1 || costType === 2">
                  <div>
                    <el-button :disabled="true" :type="setWay === '全款' ?'primary' : ''"  @click="handleSetWay('全款')">全款</el-button>
                    <el-button :disabled="true" :type="setWay === '分期' ?'primary' : ''"  @click="handleSetWay('分期')">分期</el-button>
                  </div>
              </el-form-item> 

            <el-form-item  v-if="costType === 1 || costType === 2">
              <div style="padding-left: 100px; display: flex; margin-top: 20px;margin-bottom: 20px;" v-if="setWay === '分期' && isThereACharge === 1">
                <div style="padding-top: 7px;"><span style="padding-top: 7px;">合同金额：</span></div>
                <div>
                  <el-input :clearable="false" v-model="contractAmount" autocomplete="off" size="small" placeholder="请输入合同金额" ></el-input>
                </div>
              </div>
            </el-form-item> 


              <!-- 是否收费表格展示  =============收费表格==============收费表格=============收费表格==================收费表格===============收费表格============收费表格================收费表格   -->
              
              <div style="display: flex; height: 650px; margin-bottom: 50px;" v-if="costType === 1 && isTypeLve === 1" >


                <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                  <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 成 单 收 费 </div>
                </div>

                <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                      <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                      <div style="width: 56%; padding-top: 70px; height: 160px; ">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder=" "></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>
                  
                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择收款渠道">
                        <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                      <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('全款')"  >点击上传</el-button>
                      <div v-if="chargeCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                          <div v-for="(item,index) in chargeCollectionPicture" :key="index" style="margin-top: 4px;">
                            <img  :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="item" @click="handleView(item.url, item.width, item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                          </div>
                      </div>
                    </div>
                  </div>


                  <div style="width: 100%;height: 200px;" class="no-click"> 
                    <div style="display: flex; ">
                      <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                            <div style="width: 98%;">
                              <div class="init-b">
                                <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                  <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                  <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                  <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                  <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                </div>
                              </div>
                            </div>
                            <!-- <div style="width: 45%;margin-left: 10px;">
                              <div>
                                <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                              </div>
                            </div> -->
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -34px; ">
                        <!-- <span  @click="handleViewSet('全款','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel, chargeCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                    </div> 
                  </div>

                </div>
              </div>


              <!-- 全款 --- 家庭教育 -->
              <div style="display: flex; height: 650px; margin-bottom: 50px;" v-if="costType === 1 && isTypeLve === 2" >


                <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                  <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 成 单 收 费 </div>
                </div>

                <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyGiveHour" autocomplete="off" size="small" placeholder=" "></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessGiveHour" autocomplete="off" size="small" placeholder=" "></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择收款渠道">
                        <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                      <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('全款')"  >点击上传</el-button>
                      <div v-if="chargeCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                          <div v-for="(item,index) in chargeCollectionPicture" :key="index" style="margin-top: 4px;">
                            <img  :src="item.url" :alt="item.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="item" @click="handleView(item.url, item.width, item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                          </div>
                      </div>
                    </div>
                  </div>


                  <div style="width: 100%;height: 200px;" class="no-click"> 
                    <div style="display: flex; ">
                      <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                            <div style="width: 98%;">
                              <div class="init-b">
                                <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                  <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                  <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                  <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                  <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                </div>
                              </div>
                            </div>
                            <!-- <div style="width: 45%;margin-left: 10px;">
                              <div>
                                <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                              </div>
                            </div> -->
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -34px; ">
                        <!-- <span  @click="handleViewSet('全款','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel, chargeCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                    </div> 
                  </div>

                </div>
              </div>


              <div v-if="costType === 2 && isTypeLve === 1" >

                <div style="display: flex; height: 650px;margin-bottom: 50px;" v-for="(item, index) in renewalCollectionListWay" :key="index">

                  <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                    <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                  </div>

                  <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                        <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                        <div style="width: 56%; padding-top: 70px; height: 160px; ">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>
                    
                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>


                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                          <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                        <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('分期',index,item.chargeCollectionPicture)">点击上传</el-button>
                         <div v-for="(itmes,indexs) in item.chargeCollectionPicture" :key="indexs"  style="margin-top: -7px;"> 
                            <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                      </div>
                    </div>

                    <div style="width: 100%;height: 200px;"> 
                      <div style="display: flex; ">
                        <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                        <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                              <div style="width: 98%;">
                                <div class="init-b">
                                  <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                    <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                    <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                    <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                    <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="width: 45%;margin-left: 10px;">
                                <div>
                                  <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                                </div>
                              </div> -->
                        </div>
                      </div>
                      <div style="width: 97%; text-align: end; margin-top: -34px; ">
                          <!-- <span  @click="handleViewSet('分期','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.chargeCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                      </div> 
                    </div>

                  </div>

                </div>
              </div>


              <!-- 分期 --- 家庭教育 -->
              <div v-if="costType === 2 && isTypeLve === 2" >

                <div style="display: flex; height: 650px;margin-bottom: 50px;" v-for="(item, index) in renewalCollectionListWay" :key="index">

                  <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                    <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                  </div>

                  <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>


                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseGiveHour" autocomplete="off" size="small" placeholder="课时(赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                          <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                        <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('分期',index,item.chargeCollectionPicture)">点击上传</el-button>
                         <div v-for="(itmes,indexs) in item.chargeCollectionPicture" :key="indexs"  style="margin-top: -7px;"> 
                            <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                            <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                      </div>
                    </div>

                    <div style="width: 100%;height: 200px;"> 
                      <div style="display: flex; ">
                        <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                        <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                              <div style="width: 98%;">
                                <div class="init-b">
                                  <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                    <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                    <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                    <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                    <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="width: 45%;margin-left: 10px;">
                                <div>
                                  <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                                </div>
                              </div> -->
                        </div>
                      </div>
                      <div style="width: 97%; text-align: end; margin-top: -34px; ">
                          <!-- <span  @click="handleViewSet('分期','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.chargeCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                      </div> 
                    </div>

                  </div>

                </div>
              </div>
            

              <el-form-item label="是否续费" v-if="costType === 3">
                <el-select  v-model="isYouWantToRenew" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否续费" @change="changeisYouWantToRenew" size="small">
                  <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="课程类型" v-if="costType === 3 && isYouWantToRenew === 1">
                <el-select  :disabled="true" v-model="isTypeLves" filterable  :clearable="false" style="width: 100%;" placeholder="请选择课程类型"  size="small">
                  <el-option v-for="item in payTypeLsit11" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <!-- 表格==============续费表格===========================续费表格====================================续费表格=======================续费表格===== -->

              <div v-if="costType === 3 && isTypeLves === 1" >
                <div style="display: flex; height: 650px;margin-bottom: 50px;" v-for="(item, index) in renewalCollectionList" :key="index">


                  <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                    <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '续 费 第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                  </div>


                  <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                        <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                        <div style="width: 56%; padding-top: 70px; height: 160px; ">
                          <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>
                    
                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>


                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                          <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                      <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex;">
                        <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('续费',index,item.renewCollectionPicture)">点击上传</el-button>

                        <div v-if="item.renewCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                            <div v-for="(itmes,indexs) in item.renewCollectionPicture" :key="indexs" style="margin-top: 12px;">
                              <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                              <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                            </div>
                        </div>
                      </div>
                    </div>


                    <div style="width: 100%;height: 200px;"> 
                      <div style="display: flex; ">
                        <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                        <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                              <div style="width: 98%;">
                                <div class="init-b">
                                  <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                    <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                    <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                    <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                    <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="width: 45%;margin-left: 10px;">
                                <div>
                                  <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                                </div>
                              </div> -->
                        </div>
                      </div>
                      <div style="width: 97%; text-align: end; margin-top: -34px; ">
                          <!-- <span  @click="handleViewSet('续费','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.renewCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                      </div> 
                    </div>

                
                  </div>

                </div>
              </div>


               <!-- 分期 --- 家庭教育 -->
              <div v-if="costType === 3 && isTypeLves === 2" >
                <div style="display: flex; height: 650px;margin-bottom: 50px;" v-for="(item, index) in renewalCollectionList" :key="index">


                  <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                    <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '续 费 第 ' + handleToString(item.periodsNumber) + ' 期'  }} </div>
                  </div>


                  <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                      <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.happyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.parentAwarenessGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.familyProblemGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>
                    
                      <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.patriarchReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.childReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>


                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.educationPerceiveGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                          </div>
                        </div>
                      </div>

                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.fenCaseGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                          </div>
                        </div>
                      </div>


                      <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 50px;">
                          <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                          <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                        <div style="display: flex; height: 60px;">
                          <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                          <div style="width: 56%; padding-top: 10px;">
                            <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="item.affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                          </div>
                        </div>
                      </div>

                      

                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click">
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="no-click"> 
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
                      <div style="width: 2250px; padding-top: 20px;">
                        <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                          <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div>

                    <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                      <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
                      <div style="width: 2250px; padding: 15px 0px; display: flex;">
                        <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns no-click" @click="handleUpload('续费',index,item.renewCollectionPicture)">点击上传</el-button>

                        <div v-if="item.renewCollectionPicture.length > 0" style="margin-top: -7px;display: flex;"> 
                            <div v-for="(itmes,indexs) in item.renewCollectionPicture" :key="indexs" style="margin-top: 12px;">
                              <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                              <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                            </div>
                        </div>
                      </div>
                    </div>


                    <div style="width: 100%;height: 200px;"> 
                      <div style="display: flex; ">
                        <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                        <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                              <div style="width: 98%;">
                                <div class="init-b">
                                  <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                    <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                    <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                    <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                    <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="width: 45%;margin-left: 10px;">
                                <div>
                                  <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="item.chengRemarksssss"> </el-input>
                                </div>
                              </div> -->
                        </div>
                      </div>
                      <div style="width: 97%; text-align: end; margin-top: -34px; ">
                          <!-- <span  @click="handleViewSet('续费','','customerInformationCollectionAudit/updateCommit',item.chengRemarksssss,{ PaymentTime: item.PaymentTime, Paymentchannel: item.Paymentchannel , chargeCollectionPicture: item.renewCollectionPicture })" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                      </div> 
                    </div>

                
                  </div>

                </div>
              </div>

          </div>



        <div v-if="costType === 4 && isTypeLvess === 1" style="width: 100%;">


            <div style="display: flex; height: 650px; margin-bottom: 50px;">


              <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 退费信息 </div>
              </div>

              <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                    <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                    <div style="width: 56%; padding-top: 70px; height: 160px; ">
                      <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""></el-input>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>
                
                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="">
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费时间</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class=""> 
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费渠道</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择退费渠道">
                      <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费截图</div>
                  <div style="width: 2250px; padding: 15px 0px ; display: flex;">
                    <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns " @click="handleUpload('退费')">点击上传</el-button>
                    <div v-if="chargeCollectionPicture.length > 0" style="display: flex;"> 
                        <div v-for="(itmes,indexs) in chargeCollectionPicture" :key="indexs" style="margin-top: 12px; display: flex;">
                          <img :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                          <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                    </div>
                  </div>
                </div>

                <div style="width: 100%;height: 200px;"> 
                  <div style="display: flex; ">
                    <div style="width: 131px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                          <div style="width: 98%;">
                            <div class="init-b">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                            </div>
                          </div>
                          <!-- <div style="width: 45%;margin-left: 10px;">
                            <div>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                            </div>
                          </div> -->
                    </div>
                  </div>
                  <div style="width: 97%; text-align: end; margin-top: -34px; ">
                      <!-- <span  @click="handleViewSet('退费','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel , chargeCollectionPicture})" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                  </div> 
                </div>

              </div>
            </div>

        </div>


        <!-- 退费  家庭教育 -->
        <div v-if="costType === 4 && isTypeLvess === 2" style="width: 100%;">


            <div style="display: flex; height: 650px; margin-bottom: 50px;">


              <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 退费信息 </div>
              </div>

              <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">快乐探索之旅</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">父母觉知课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家庭问题梳理诊断</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长复盘</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">孩子复盘</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">教育认知及政策同步</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">冯导个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">亲密关系的秘密</div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; " class="no-click">

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="happyGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="parentAwarenessGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="familyProblemGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>
                
                  <div style="width:  14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="patriarchReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="childReplayGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="educationPerceiveGiveHour" autocomplete="off" size="small" placeholder=" (赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="fenCaseGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 14.22%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">费用</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">课本</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">课本(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :clearable="false" v-model="affinityBookGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>


                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class="">
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费时间</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-date-picker style=" width: 25%; margin-left: 10px;" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; " class=""> 
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费渠道</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-select style="width: 25%; margin-left: 10px;"  filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择退费渠道">
                      <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <div style="width: 129px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>退费截图</div>
                  <div style="width: 2250px; padding: 15px 0px ; display: flex;">
                    <el-button size="small" style=" margin-left: 10px;"  type="primary" class="btns " @click="handleUpload('退费')">点击上传</el-button>
                    <div v-if="chargeCollectionPicture.length > 0" style="display: flex;"> 
                        <div v-for="(itmes,indexs) in chargeCollectionPicture" :key="indexs" style="margin-top: 12px; display: flex;">
                          <img :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 45px; margin-left: 10px;margin-top: -7px;" >
                          <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        </div>
                    </div>
                  </div>
                </div>

                <div style="width: 100%;height: 200px;"> 
                  <div style="display: flex; ">
                    <div style="width: 129px; text-align: center;padding-top: 50px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;height: 190px;">备注</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex; height: 180px;">
                          <div style="width: 98%;">
                            <div class="init-b">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                            </div>
                          </div>
                          <!-- <div style="width: 45%;margin-left: 10px;">
                            <div>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 8, maxRows: 8 }"  v-model="chengRemarksssss"> </el-input>
                            </div>
                          </div> -->
                    </div>
                  </div>
                  <div style="width: 97%; text-align: end; margin-top: -34px; ">
                      <!-- <span  @click="handleViewSet('退费','','customerInformationCollectionAudit/updateCommit',chengRemarksssss,{ PaymentTime, Paymentchannel , chargeCollectionPicture})" style="color: #0999e1;margin-left: 10px;">再次审批</span> -->
                  </div> 
                </div>

              </div>
            </div>

        </div>



        <el-divider content-position="center">提交人信息</el-divider>


        <el-form-item label="提交人:"  style="width: 50%;"> {{ order.commitName }}  </el-form-item>
        <!-- <el-form-item label="备注:"  style="width: 50%;"> {{ order.remark[0].remark }}  </el-form-item> -->
        <el-form-item label="审批人:"  style="width: 50%;"> {{ order.auditName }}  </el-form-item>
        <el-form-item label="审批状态:"  style="width: 50%; color: red; " v-if="order.auditStatus === 0"> 待审批 </el-form-item>
        <el-form-item label="审批状态:"  style="width: 50%; color: red;" v-if="order.auditStatus === 1"> 驳回 </el-form-item>
        <el-form-item label="审批状态:"  style="width: 50%; color: green;" v-if="order.auditStatus === 2"> 已完成 </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <div style="text-align: end;">
          <el-button size="small" type="danger" @click="closeEditDialogReject" v-if="orderFormComponentsType === '审批' ">驳回</el-button>
          <el-button size="small" type="primary" @click="closeEditDialogSubt" v-if="orderFormComponentsType === '审批' || orderFormComponentsType === '编辑' ">确认</el-button>
          <el-button size="small"  @click="closeEditDialog">关闭</el-button>
        </div>
        <!--            <el-button type="primary" @click="saveEditForm">保存</el-button>-->
      </span>
    </el-dialog>


    <rejectDialogComponents ref="rejectDialogComponents" :customerId="customerId" v-if="rejectDialogShow" :rowOrder="order"  @handleEventBus="handleEventBus" @handleEventBusSbut="handleEventBusSbut"></rejectDialogComponents>

    <Elupload
      v-if="isShowElupload"
      @handleEventElUpload="handleEventElUpload"
      @handleEventElUploadSubt="handleEventElUploadSubt"
      :Uploadtypes="Uploadtypes"
      :fileAllLists="fileAllLists"
    ></Elupload>


    
  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false"   :visible="isImg" :before-close="closeisImg" width="60%">
          <!-- <img  :src="isImgs" :alt="isImgs" style="width: 100%; height: 550px; margin: 10px;" > -->
          <img  :src="isImgs" :alt="isImgs" :style="{ width: imgWidth ? imgWidth + 'px' : '100%', height: imgHeight ? imgHeight + 'px' : '550px', margin: '10px', }">
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="closeisImg">取 消</el-button>
            </div>
          </div>
  </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import rejectDialogComponents from './rejectDialog.vue'
import Elupload from "./Elupload.vue";

export default {
  components: { rejectDialogComponents, Elupload },
  props:['orderFormComponentsType', 'orderFormComponentsID', 'typeCustomerFunding', 'isUrView','uploadingPicture'],
  data () {
    return {

        happyMoney: '',
        happyHour: '',
        happyGiveHour: '',
        parentAwarenessMoney: '',
        parentAwarenessHour: '',
        parentAwarenessGiveHour: '',
        familyProblemMoney: '',
        familyProblemHour: '',
        familyProblemGiveHour: '',
        patriarchReplayMoney: '',
        patriarchReplayHour: '',
        patriarchReplayGiveHour: '',
        childReplayMoney: '',
        childReplayHour: '',
        childReplayGiveHour: '',
        educationPerceiveMoney: '',
        educationPerceiveHour: '',
        educationPerceiveGiveHour: '',
        fenCaseMoney: '',
        fenCaseHour: '',
        fenCaseGiveHour: '',


        affinityBookMoney : '',
        affinityBookHour : '',
        affinityBookGiveHour : '',

        isTypeLve: 1,
        isTypeLves: 1,
        isTypeLvess: 1,
        payTypeLsit11: [{ id: 1, name: '学业课' }, { id: 2, name: '家庭教育课' }],

        fileAllLists_DINGJIN: [],

        RemoteRoadRepairClass:'', 
        RemoteRoadRepairGiveHour:'', 

        imgWidth: 0,
        imgHeight: 0,


        isImg:false,
        isImgs:'',

        classGiveHour:'', 
        familyGiveHour:'',
        readingGiveHour:'',


        isCustomerStatus: '',
        isClassTypeTxts: '',

        teacherss: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],

        periodsNumber: '',

        optionOrderStatus: [{id:0,name:'待成单'},{id:1,name:'已成单'},{id:2,name:'未成单'},{id:3,name:'已退费'}],

        isOrderStatus: false,


        paymentAmount: '',
        paymentAmountTime: '',
        paymentAmountChannel: '',
        paymentAmountCourse: '',


        diagnoseMoney : '',
        diagnoseHour  : '',
        diagnoseGiveHour  : '',

        studentMoney: '',
        studentHour: '',
        studentGiveHour: '',

        patriarchMoney: '',
        patriarchHour: '',
        patriarchGiveHour: '',

        isClassType: '',


        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
          {dictValue:"深圳", dictType:3 },
        ],

        OrderStatus: 0,

        costType: '',

        setWay: '',
        renewalCollectionListWay: [],

        chengRemarks:'',
        ApprovalPeople: 63,
        optionList2:[],

        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        checked: false,
        checked1: false,

      rejectDialogShow:false,
      expireTimeOption: {
        disabledDate (date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      contractAmount:'',
      teachers: [], //老师集合
      categoryList: [], //课程集合
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      payTypes: [
          {
            value: 1,
            label: "现金"
          },
          {
            value: 2,
            label: "微信"
          },
          {
            value: 3,
            label: "支付宝"
          },
          {
            value: 4,
            label: "银行卡"
          },
          {
            value: 5,
            label: "公户"
          },
          {
            value: 6,
            label: "小鹅通"
          },{
            value: 7,
            label: "美团"
          }
           ,{
            value: 8,
            label: "公户（桑穆）"
          }
           ,{
            value: 9,
            label: "公户（博川）"
          },
          {
            value: 10,
            label: "公户（蒙正心理）"
          },
      ], // 收款渠道选项
      customer: {},
      order: {
        renew: [
          {
            renewType: "",//续费方式
            renewTime: "",//续费时间
            renewMoney: ""//续费金额
          }
        ],
        isRenew: "",//是否续费
        orderStatus: "",
        remarks: "",//备注
        customerIsallpay: "",
        onlineStatus: "1",//线上诊断标识x
        offlineStatus: "1",//线下诊断标识
        teacherIdOnline: "",//线上诊断老师
        teacherIdOffline: "",//线下诊断老师
        onlineTime: [],// 线上诊断时间
        offlineTime: [],// 线下诊断时间
        startTimeDay: "", //诊断时间天数
        startTimeHour: "", //诊断时间小时段
        gradeIdArrToStr: "", //年级字符串
        categoryIdArrToStr: "", //年级字符串
        orderIspay: "",
        isDiagnosisAllPay: "", //是否交诊断费
        customerPaymoney: "", //诊断费用
        customerPaytime: "", //诊断费用收款时间
        payType: "", //诊断费用付款方式
        payAllType2: "", //诊断费用付款方式
        customerAllpaymoney: "", //全款费用
        customerAllpaytime: "", //交全款时间
        isAllPay: "",
        payType2: "", //诊断费用
        orderIsallpay: "", //付款方式
        studentName: "", //学生姓名
        gradeList: [], //年级
        grade: [], //年级id
        classType: '',
        sex: "", // 性别
        address: "", //家庭地址
        parentPhoneNumber: "", //家长电话
        teacherId: "", //老师id
        teacherName: "", //老师id
        startTime: "", //授课时间
        payAlltype: "", //全款付款方式
        categoryId: "", //课程id
        type: "", //成交状态
        customerInformationId: "", //客资id
        classHour: "",
        familyHour: "",
        stages: [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "" // 收款渠道
          }
        ]
      },
      showEdit: false,
      rules: {
        studentName: [
          {
            required: true,
            message: "请输入学生名称",
            trigger: "blur"
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: "change"
          }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [
          {
            required: true,
            message: "请输入家庭住址",
            trigger: "blur"
          }
        ],
        categoryId: [
          { required: true, message: "请选择课程类别", trigger: "change" }
        ],
        teacherId: [
          { required: true, message: "请选择授课教师", trigger: "change" }
        ],
        startTime: [
          { required: true, message: "请选择授课时间", trigger: "change" }
        ]
      },

      classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],

      isOrderStatusTextarea:'',

      teachers: [
        {
          value: 1,
          label: "小单老师",
        },
        {
          value: 2,
          label: "大单老师",
        },
        {
          value: 3,
          label: "刘老师",
        },
        {
          value: 4,
          label: "杨老师",
        },
      ],


      isThereAChargeList: [{id:1, name:'是'},{id:2, name:'否'}],
      isThereACharge:'',
      isThereACharge1:'',

      chengRemarksssss:'',
      doubtContent:[],
      


      Plan:'',
      AcademicExpenses:'',
      AcademicClasses:'',
      FamilyEducationExpenses:'',
      FamilyEducationClass:'',
      AccompanyingReadingFee:'',
      AccompanyingReading:'',
      PaymentTime:'',
      Paymentchannel:'',
      RemoteRoadRepair:'',
      customerReturnType:'',

      isYouWantToRenewList: [{id:1,name:'是'},{id:2,name:'否'}],
      isYouWantToRenew:'',




      renewalCollectionList:[
        {
          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          RemoteRoadRepair:'',
          PaymentTime:'',
          Paymentchannel:'',
          classGiveHour:'', 
          familyGiveHour:'',
          readingGiveHour:'',

        }
      ],





      isThereARefundList: [{id:1,name:'是'},{id:2,name:'否'}],
      isThereARefund:'',


      isWantToContinueTheClass:'',


      isDetail: false,


      fileAllLists:[],
      Uploadtypes:"",
      isShowElupload: false,

      
      isThereARefundListt: [{id:1,name:'是'},{id:2,name:'否'}],  
      isCustomsDeclarationchengRemarks: '',
      isCustomsDeclaration: 2,

      chargeCollectionPicture:[],

      ObjRow: {}
    };
  },
  computed: {},
  watch: {},
  methods: {

    handleView(value, width = 0, height = 0){
        this.isImg = true
        this.imgWidth = width
        this.imgHeight = height 
        this.isImgs = value
    },

    closeisImg(){
      this.isImg = false
      this.isImgs = ''
      this.imgWidth = 0
      this.imgHeight = 0
    },


    handleSetWay (type) {
       this.setWay = type;
    },

    handleEventElUploadSubt(flileList) {


      this.isShowElupload = false;
      if (flileList && flileList.length > 0) {
         this.fileAllLists= [...flileList,...this.fileAllLists]
      }

      this.chargeCollectionPicture = [...this.fileAllLists,...this.chargeCollectionPicture]
      

    },
    handleEventElUpload(flileList) {
      this.isShowElupload = false;
    },

    handleUpload(type) {
      this.Uploadtypes = type
      this.fileAllLists = []
      

      if (type === "1" ) {

      }

      if (type === "2") {

      }

      this.isShowElupload = true
    },

    handleToString (num) {
        const CN_NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        const CN_UNIT = ['', '十', '百', '千'];
        const CN_SECTION = ['', '万', '亿', '万亿'];

        // 非数字处理
        if (typeof num !== 'number' || isNaN(num)) return '';

        // 处理负数
        if (num < 0) {
            return '负' + arabicToChinese(-num);
        }

        // 分割整数与小数部分
        const parts = num.toFixed(2).split('.');
        const intPart = parts[0];
        const decPart = parts[1];

        let result = '';
        let zeroFlag = false;

        // 分段处理整数部分（每4位一组）
        const sections = [];
        let temp = intPart;
        while (temp.length > 4) {
            sections.unshift(temp.slice(-4));
            temp = temp.slice(0, -4);
        }
        sections.unshift(temp.padStart(4, '0').slice(-4)); // 补齐前导0

        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            let sectionStr = '';
            zeroFlag = false;

            for (let j = 0; j < section.length; j++) {
                const digit = parseInt(section[j]);
                const unit = CN_UNIT[section.length - j - 1];

                if (digit === 0) {
                    zeroFlag = true;
                } else {
                    if (zeroFlag) {
                        // sectionStr += CN_NUM[0];
                        zeroFlag = false;
                    }
                    sectionStr += CN_NUM[digit] + (digit !== 0 ? unit : '');
                }
            }

            if (sectionStr !== '') {
                // 去掉末尾多余的“零”
                if (sectionStr.endsWith('零')) {
                    sectionStr = sectionStr.slice(0, -1);
                }
                result += sectionStr + CN_SECTION[sections.length - i - 1];
            }
        }

        // 如果整数部分为空，表示是纯小数
        if (!result) {
            result = CN_NUM[0];
        }

        // 处理小数部分
        if (decPart && decPart !== '00') {
            result += '点';
            for (let i = 0; i < decPart.length; i++) {
                const digit = parseInt(decPart[i]);
                result += CN_NUM[digit];
            }
        }

        return result;
    },

    changeisWantToContinueTheClass (val) {
        console.log(val, '(changeisWantToContinueTheClass)')
    },

    changeisThereACharge (val) {
        console.log(val, '(changeisThereACharge)')
    },

    changeisThereACharge1 (val) {
        console.log(val, '(changeisThereACharge1)')
    },


    changeisYouWantToRenew (val) {
        console.log(val, '(changeisYouWantToRenew)')
    },

    closeisOrderStatus(val) {
      this.isOrderStatusTextarea = ''
      this.isOrderStatus = false
    },

    changeCustomerFunding (val) {

    },

    changeOrderStatus (val) {
        if(val === 2){
           this.isOrderStatus = true
        }else{
          this.isOrderStatus = false
        }
    },

    changeisThereARefund (val) {
          console.log(val, '(changeisThereARefund)')
          if(val === 2){
            this.isCustomsDeclarationchengRemarks = ''
          }
    },

    handleViewSet(type, index, url, Remark, { PaymentTime, Paymentchannel, chargeCollectionPicture }){

        if(PaymentTime && Paymentchannel && chargeCollectionPicture.length > 0){

       

          this.ObjRow.commitRemark = Remark

          if(type === '全款'){
             this.ObjRow.projectMoney = this.Plan
             this.ObjRow.diagnoseMoney = this.diagnoseMoney
             this.ObjRow.diagnoseHour = this.diagnoseHour
             this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
             this.ObjRow.studentMoney = this.studentMoney
             this.ObjRow.studentHour = this.studentHour
             this.ObjRow.studentGiveHour = this.studentGiveHour
             this.ObjRow.patriarchMoney = this.patriarchMoney
             this.ObjRow.patriarchHour = this.patriarchHour
             this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
             this.ObjRow.chargeCollectionPicture = this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : '[]'
             this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
             this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
             this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
             this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
             this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
             this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
             this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
             this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
             this.ObjRow.payTime = this.PaymentTime ? this.PaymentTime  : ''
             this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
             this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
             this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
             this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
          }
          if(type === '分期'){
             this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan
             this.ObjRow.diagnoseMoney = this.renewalCollectionListWay[0].diagnoseMoney
             this.ObjRow.diagnoseHour = this.renewalCollectionListWay[0].diagnoseHour
             this.ObjRow.diagnoseGiveHour = this.renewalCollectionListWay[0].diagnoseGiveHour
             this.ObjRow.studentMoney = this.renewalCollectionListWay[0].studentMoney
             this.ObjRow.studentHour = this.renewalCollectionListWay[0].studentHour
             this.ObjRow.studentGiveHour = this.renewalCollectionListWay[0].studentGiveHour
             this.ObjRow.patriarchMoney = this.renewalCollectionListWay[0].patriarchMoney
             this.ObjRow.patriarchHour = this.renewalCollectionListWay[0].patriarchHour
             this.ObjRow.patriarchGiveHour = this.renewalCollectionListWay[0].patriarchGiveHour
             this.ObjRow.chargeCollectionPicture = this.renewalCollectionListWay[0].chargeCollectionPicture.length > 0 ? JSON.stringify(this.renewalCollectionListWay[0].chargeCollectionPicture) : '[]'
             this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : ''
             this.ObjRow.allPayMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
             this.ObjRow.classHour = this.renewalCollectionListWay[0].AcademicClasses ? this.renewalCollectionListWay[0].AcademicClasses  : ''
             this.ObjRow.familyHour = this.renewalCollectionListWay[0].FamilyEducationClass ? this.renewalCollectionListWay[0].FamilyEducationClass  : ''
             this.ObjRow.familyMoney = this.renewalCollectionListWay[0].FamilyEducationExpenses ? this.renewalCollectionListWay[0].FamilyEducationExpenses  : ''
             this.ObjRow.readingPartnerMoney = this.renewalCollectionListWay[0].AccompanyingReadingFee ? this.renewalCollectionListWay[0].AccompanyingReadingFee  : ''
             this.ObjRow.readingPartnerHour = this.renewalCollectionListWay[0].AccompanyingReading ? this.renewalCollectionListWay[0].AccompanyingReading  : ''
             this.ObjRow.wayMoney = this.renewalCollectionListWay[0].RemoteRoadRepair ? this.renewalCollectionListWay[0].RemoteRoadRepair  : ''
             this.ObjRow.payTime = this.renewalCollectionListWay[0].PaymentTime ? this.renewalCollectionListWay[0].PaymentTime  : ''
             this.ObjRow.payAlltype = this.renewalCollectionListWay[0].Paymentchannel ? this.renewalCollectionListWay[0].Paymentchannel  : ''
             this.ObjRow.classGiveHour = this.renewalCollectionListWay[0].classGiveHour ? this.renewalCollectionListWay[0].classGiveHour  : ''
             this.ObjRow.familyGiveHour = this.renewalCollectionListWay[0].familyGiveHour ? this.renewalCollectionListWay[0].familyGiveHour  : ''
             this.ObjRow.readingGiveHour = this.renewalCollectionListWay[0].readingGiveHour ? this.renewalCollectionListWay[0].readingGiveHour  : ''
          }
          if(type === '续费'){
             this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : ''
             this.ObjRow.diagnoseMoney = this.renewalCollectionListWay[0].diagnoseMoney ? this.renewalCollectionListWay[0].diagnoseMoney  : ''
             this.ObjRow.diagnoseHour = this.renewalCollectionListWay[0].diagnoseHour ? this.renewalCollectionListWay[0].diagnoseHour  : ''
             this.ObjRow.diagnoseGiveHour = this.renewalCollectionListWay[0].diagnoseGiveHour ? this.renewalCollectionListWay[0].diagnoseGiveHour  : ''
             this.ObjRow.studentMoney = this.renewalCollectionListWay[0].studentMoney ? this.renewalCollectionListWay[0].studentMoney  : ''
             this.ObjRow.studentHour = this.renewalCollectionListWay[0].studentHour ? this.renewalCollectionListWay[0].studentHour  : ''
             this.ObjRow.studentGiveHour = this.renewalCollectionListWay[0].studentGiveHour ? this.renewalCollectionListWay[0].studentGiveHour  : ''
             this.ObjRow.patriarchMoney = this.renewalCollectionListWay[0].patriarchMoney ? this.renewalCollectionListWay[0].patriarchMoney  : ''
             this.ObjRow.patriarchHour = this.renewalCollectionListWay[0].patriarchHour ? this.renewalCollectionListWay[0].patriarchHour  : ''
             this.ObjRow.patriarchGiveHour = this.renewalCollectionListWay[0].patriarchGiveHour ? this.renewalCollectionListWay[0].patriarchGiveHour  : ''
             this.ObjRow.chargeCollectionPicture = this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : '[]'
             this.ObjRow.projectMoney = this.renewalCollectionListWay[0].Plan ? this.renewalCollectionListWay[0].Plan  : ''
             this.ObjRow.allPayMoney = this.renewalCollectionListWay[0].AcademicExpenses ? this.renewalCollectionListWay[0].AcademicExpenses  : ''
             this.ObjRow.classHour = this.renewalCollectionListWay[0].AcademicClasses ? this.renewalCollectionListWay[0].AcademicClasses  : ''
             this.ObjRow.familyHour = this.renewalCollectionListWay[0].FamilyEducationClass ? this.renewalCollectionListWay[0].FamilyEducationClass  : ''
             this.ObjRow.familyMoney = this.renewalCollectionListWay[0].FamilyEducationExpenses ? this.renewalCollectionListWay[0].FamilyEducationExpenses  : ''
             this.ObjRow.readingPartnerMoney = this.renewalCollectionListWay[0].AccompanyingReadingFee ? this.renewalCollectionListWay[0].AccompanyingReadingFee  : ''
             this.ObjRow.readingPartnerHour = this.renewalCollectionListWay[0].AccompanyingReading ? this.renewalCollectionListWay[0].AccompanyingReading  : ''
             this.ObjRow.wayMoney = this.renewalCollectionListWay[0].RemoteRoadRepair ? this.renewalCollectionListWay[0].RemoteRoadRepair  : ''
             this.ObjRow.payTime = this.renewalCollectionListWay[0].PaymentTime ? this.renewalCollectionListWay[0].PaymentTime  : ''
             this.ObjRow.payAlltype = this.renewalCollectionListWay[0].Paymentchannel ? this.renewalCollectionListWay[0].Paymentchannel  : ''
             this.ObjRow.classGiveHour = this.renewalCollectionListWay[0].classGiveHour ? this.renewalCollectionListWay[0].classGiveHour  : ''
             this.ObjRow.familyGiveHour = this.renewalCollectionListWay[0].familyGiveHour ? this.renewalCollectionListWay[0].familyGiveHour  : ''
             this.ObjRow.readingGiveHour = this.renewalCollectionListWay[0].readingGiveHour ? this.renewalCollectionListWay[0].readingGiveHour  : ''
          }
          if(type === '退费'){
             this.ObjRow.projectMoney = this.Plan
             this.ObjRow.diagnoseMoney = this.diagnoseMoney
             this.ObjRow.diagnoseHour = this.diagnoseHour
             this.ObjRow.diagnoseGiveHour = this.diagnoseGiveHour
             this.ObjRow.studentMoney = this.studentMoney
             this.ObjRow.studentHour = this.studentHour
             this.ObjRow.studentGiveHour = this.studentGiveHour
             this.ObjRow.patriarchMoney = this.patriarchMoney
             this.ObjRow.patriarchHour = this.patriarchHour
             this.ObjRow.patriarchGiveHour = this.patriarchGiveHour
             this.ObjRow.chargeCollectionPicture = this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : '[]'
             this.ObjRow.projectMoney = this.Plan ? this.Plan  : ''
             this.ObjRow.allPayMoney = this.AcademicExpenses ? this.AcademicExpenses  : ''
             this.ObjRow.classHour = this.AcademicClasses ? this.AcademicClasses  : ''
             this.ObjRow.familyHour = this.FamilyEducationClass ? this.FamilyEducationClass  : ''
             this.ObjRow.familyMoney = this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : ''
             this.ObjRow.readingPartnerMoney = this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : ''
             this.ObjRow.readingPartnerHour = this.AccompanyingReading ? this.AccompanyingReading  : ''
             this.ObjRow.wayMoney = this.RemoteRoadRepair ? this.RemoteRoadRepair  : ''
             this.ObjRow.payTime = this.PaymentTime ? this.PaymentTime  : ''
             this.ObjRow.payAlltype = this.Paymentchannel ? this.Paymentchannel  : ''
             this.ObjRow.classGiveHour = this.classGiveHour ? this.classGiveHour  : ''
             this.ObjRow.familyGiveHour = this.familyGiveHour ? this.familyGiveHour  : ''
             this.ObjRow.readingGiveHour = this.readingGiveHour ? this.readingGiveHour  : ''
          }


          axios.post(`${apiBaseUrl}/${url}`, this.ObjRow,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            if (res.data.code === 200) {
                this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
            }else{
              this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
            }
          }).catch((err)=>{
            this.$message({  message: err ,  type: "error" });
          })


        }else{
          this.$message({  message: '请输入必填项',  type: "warning" });
        }    
    },


    addInput1 () {
      this.renewalCollectionList.push({
        AcademicExpenses:'',
        AcademicClasses:'',
        FamilyEducationExpenses:'',
        FamilyEducationClass:'',
        AccompanyingReadingFee:'',
        AccompanyingReading:'',
        RemoteRoadRepair:'',
        PaymentTime:'',
        Paymentchannel:'',
        classGiveHour:'', 
        familyGiveHour:'',
        readingGiveHour:'',
      })
    },
    removeItem1 () {
      if (this.renewalCollectionList.length > 1) {
          this.renewalCollectionList.pop()
      } else {
          this.renewalCollectionList.splice(0, this.renewalCollectionList.length)
      }
    },

    startTimeSelect (val, row) {

      if (val == "start") {
        this.order.OffTimeHour = row
      } else if (val == "end") {
        this.order.offEndTime = row
      } else if (val == "start1") {
        this.order.startTimeHour = row
      } else {
        this.order.onEndTime = row
      }

    },

    endTimeSelect (val) {
      this.order.offEndTime = val
    },

    orderCustomerAudit(customerId){
      this.customerId = customerId;
      this.showEdit = true;

      // orderCustomerAudit/details

      // customerInformationAuditInfo

      // customerInformationAuditInfo/details

      axios.get(`${apiBaseUrl}/customerInformationCollectionAudit/getOne/${customerId}`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}) .then(res => {
          if (res.data.code === 200) {


             // 是否为分期 || 全款
            this.setWay = res.data.data.collectionType === 1 ? '全款' : res.data.data.collectionType === 2 ? '分期' : ''

            this.order = res.data.data


            this.isClassType = res.data.data.classType

            this.costType = res.data.data.costType




            this.isCustomerStatus = res.data.data.customerType
            this.customerReturnType = res.data.data.customerReturnType

            this.isClassTypeTxts = res.data.data.classType === 1 ? '规划' : res.data.data.classType === 2 ? '线下' : res.data.data.classType === 3 ? '纯补课' : ''

            this.chengRemarks = res.data.data.commitRemark
            this.order.remark = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []
            this.ApprovalPeople = res.data.data.auditId


            this.fileAllLists = [{ url: res.data.data.uploadingPicture }]


            // =========================================================(定金)=======================================================
            this.OrderStatus = res.data.data.orderStatus
            this.paymentAmount = res.data.data.customerPaymoney
            this.paymentAmountTime = res.data.data.customerPaytime
            this.paymentAmountChannel = res.data.data.payType
            this.paymentAmountCourse = res.data.data.customerHour
            this.isOrderStatusTextarea = res.data.data.notCustomerRemark

            const picData = res.data.data.diagnosisCollectionPicture;
            if (typeof picData === 'string') {
              try {
                this.fileAllLists_DINGJIN = JSON.parse(picData);
              } catch (e) {
                this.fileAllLists_DINGJIN = [];
              }
            } else {
              this.fileAllLists_DINGJIN = [];
            }




           
            


            // =========================================================(成单)=======================================================
            // (1) 是否收费
            this.isThereACharge = res.data.data.customerIsallpay
            this.isCustomsDeclaration = res.data.data.isClose ? res.data.data.isClose : 2
            this.isCustomsDeclarationchengRemarks = res.data.data.closeCause ? res.data.data.closeCause : ''   

            this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []
            

            // =========================================================(成单分期)=======================================================
            
            if (this.costType === 2 && res.data.data.categoryType === 1) {
              try {
                      this.renewalCollectionListWay = []
                      this.renewalCollectionListWay.push(
                             {
                                Plan: res.data.data.projectMoney || '',
                                diagnoseMoney: res.data.data.diagnoseMoney || '',
                                AcademicExpenses: res.data.data.customerAllpaymoney|| '',
                                FamilyEducationExpenses: res.data.data.familyMoney|| '',
                                patriarchMoney: res.data.data.patriarchMoney || '',
                                studentMoney: res.data.data.studentMoney || '',
                                AccompanyingReadingFee: res.data.data.readingPartnerMoney || '',
                                RemoteRoadRepair: res.data.data.wayMoney || '',
                                PaymentTime: res.data.data.stagesDate || '',
                                Paymentchannel: res.data.data.payType || '',
                                chargeCollectionPicture: res.data.data.stagesPicture ? JSON.parse(res.data.data.stagesPicture) : [],
                                diagnoseHour: res.data.data.diagnoseHour,
                                diagnoseGiveHour: res.data.data.diagnoseGiveHour,
                                studentHour: res.data.data.studentHour,
                                studentGiveHour: res.data.data.studentGiveHour,
                                patriarchHour: res.data.data.patriarchHour,
                                patriarchGiveHour: res.data.data.patriarchGiveHour,
                                AcademicClasses: res.data.data.classHour ? res.data.data.classHour : '',
                                FamilyEducationClass: res.data.data.familyHour ? res.data.data.familyHour : '',
                                AccompanyingReading: res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour : '',
                                PaymentTime: res.data.data.payTime ? res.data.data.payTime : '',
                                Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype) : '',
                                classGiveHour: res.data.data.classGiveHour ? res.data.data.classGiveHour : '',
                                familyGiveHour: res.data.data.familyGiveHour ? res.data.data.familyGiveHour : '',
                                readingGiveHour: res.data.data.readingGiveHour ? res.data.data.readingGiveHour : '',
                                sumMoney: res.data.data.sumMoney ? res.data.data.sumMoney : '',              //收款金额
                                stagesDate: res.data.data.stagesDate ? res.data.data.stagesDate : '',        //收款时间
                                payType: res.data.data.payType ? res.data.data.payType : '',                 //收款渠道


                                Plan :  res.data.data.projectMoney ? res.data.data.projectMoney  : '',
                                AcademicExpenses :  res.data.data.classMoney ? res.data.data.classMoney  : '',
                                AcademicClasses :  res.data.data.classHour ? res.data.data.classHour  : '',
                                FamilyEducationClass :  res.data.data.familyHour ? res.data.data.familyHour  : '',
                                FamilyEducationExpenses :  res.data.data.familyMoney ? res.data.data.familyMoney  : '',
                                AccompanyingReadingFee :  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : '',
                                AccompanyingReading :  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : '',
                                RemoteRoadRepair :  res.data.data.wayMoney ? res.data.data.wayMoney  : '',
                                PaymentTime :  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : '',
                                Paymentchannel :  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                                classGiveHour :  res.data.data.classGiveHour ? res.data.data.classGiveHour  : '',
                                familyGiveHour :  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : '',
                                readingGiveHour :  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : '',
                                diagnoseMoney :  res.data.data.diagnoseMoney,
                                diagnoseHour :  res.data.data.diagnoseHour,
                                diagnoseGiveHour :  res.data.data.diagnoseGiveHour,
                                studentMoney :  res.data.data.studentMoney,
                                studentHour :  res.data.data.studentHour,
                                studentGiveHour :  res.data.data.studentGiveHour,
                                patriarchMoney :  res.data.data.patriarchMoney,
                                patriarchHour :  res.data.data.patriarchHour,
                                patriarchGiveHour :  res.data.data.patriarchGiveHour,
                                chargeCollectionPicture :  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                                periodsNumber :  res.data.data.periodsNumber,
                                PaymentTime: res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : '',
                              }
                      )
                      

                      console.log(this.renewalCollectionListWay , '11111111111111111')

              } catch (e) {
                this.renewalCollectionListWay = [];
              }
            } else {
              this.renewalCollectionListWay = [];
            }


            



            // (2) 是否续费
            this.isYouWantToRenew = res.data.data.isRenew
            // (3) 是否退费
            this.isThereARefund = res.data.data.isReturnPremium
            // =========================================================(退费)=======================================================
            this.isWantToContinueTheClass = res.data.data.isContinueType

          

           if(res.data.data.costType === 1 && res.data.data.categoryType === 1){
              this.Plan = res.data.data.projectMoney
              this.AcademicExpenses = res.data.data.customerAllpaymoney
              this.AcademicClasses = res.data.data.classHour
              this.FamilyEducationExpenses = res.data.data.familyMoney
              this.FamilyEducationClass = res.data.data.familyHour
              this.AccompanyingReadingFee = res.data.data.readingPartnerMoney
              this.AccompanyingReading = res.data.data.readingPartnerHour
              this.RemoteRoadRepair = res.data.data.wayMoney
              this.PaymentTime = res.data.data.customerAllpaytime
              this.Paymentchannel = Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype) : ''
              this.classGiveHour = res.data.data.classGiveHour
              this.familyGiveHour = res.data.data.familyGiveHour
              this.readingGiveHour = res.data.data.readingGiveHour
          }
          

          this.contractAmount = res.data.data.contractCost
          
  

          if(this.costType === 1 && res.data.data.categoryType === 1){

              this.Plan =  res.data.data.projectMoney ? res.data.data.projectMoney  : ''
              this.AcademicExpenses =  res.data.data.classMoney ? res.data.data.classMoney  : ''
              this.AcademicClasses =  res.data.data.classHour ? res.data.data.classHour  : ''
              this.FamilyEducationClass =  res.data.data.familyHour ? res.data.data.familyHour  : ''
              this.FamilyEducationExpenses =  res.data.data.familyMoney ? res.data.data.familyMoney  : ''
              this.AccompanyingReadingFee =  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : ''
              this.AccompanyingReading =  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : ''

              this.RemoteRoadRepair =  res.data.data.wayMoney ? res.data.data.wayMoney  : ''
              this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate  : ''
              this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
              this.classGiveHour =  res.data.data.classGiveHour ? res.data.data.classGiveHour  : ''
              this.familyGiveHour =  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : ''
              this.readingGiveHour =  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : ''
              
              this.diagnoseMoney =  res.data.data.diagnoseMoney
              this.diagnoseHour =  res.data.data.diagnoseHour
              this.diagnoseGiveHour =  res.data.data.diagnoseGiveHour
              this.studentMoney =  res.data.data.studentMoney
              this.studentHour =  res.data.data.studentHour
              this.studentGiveHour =  res.data.data.studentGiveHour
              this.patriarchMoney =  res.data.data.patriarchMoney
              this.patriarchHour =  res.data.data.patriarchHour
              this.patriarchGiveHour =  res.data.data.patriarchGiveHour
              this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
              this.periodsNumber = res.data.data.periodsNumber
          }


          // (2) 是否续费
          this.isYouWantToRenew = res.data.data.isRenew === 1 ? 1 : 2
          


          if(this.costType === 3 && res.data.data.categoryType === 1){
                    this.renewalCollectionList = []
                    this.renewalCollectionList.push(
                    {

                          Plan: res.data.data.projectMoney,
                          AcademicExpenses : res.data.data.renewMoney,
                          AcademicClasses : res.data.data.classHourRenew,
                          FamilyEducationExpenses : res.data.data.familyMoney,
                          FamilyEducationClass : res.data.data.familyHourRenew,
                          AccompanyingReadingFee : res.data.data.readingPartnerMoney,
                          AccompanyingReading : res.data.data.readingPartnerHour,
                          RemoteRoadRepair: res.data.data.wayMoney,
                          PaymentTime : res.data.data.renewTime,
                          Paymentchannel : res.data.data.renewType,
                          classGiveHour: res.data.data.classGiveHour, 
                          familyGiveHour: res.data.data.familyGiveHour,
                          readingGiveHour: res.data.data.readingGiveHour, 

                          diagnoseHour: res.data.data.diagnoseHour || '',
                          diagnoseMoney: res.data.data.diagnoseMoney || '',
                          diagnoseGiveHour: res.data.data.diagnoseGiveHour || '',
                          patriarchHour: res.data.data.patriarchHour || '',
                          patriarchGiveHour: res.data.data.patriarchGiveHour || '',
                          patriarchMoney: res.data.data.patriarchMoney || '',
                          studentHour: res.data.data.studentHour || '',
                          studentGiveHour: res.data.data.studentGiveHour || '',
                          studentMoney: res.data.data.studentMoney || '',
                          renewCollectionPicture: res.data.data.renewCollectionPicture ? JSON.parse(res.data.data.renewCollectionPicture) : [],

                          sumMoney: res.data.data.sumMoney,            //收款金额
                          renewTime: res.data.data.renewTime,          //收款时间
                          renewType: res.data.data.renewType,          //收款渠道

                          Plan:  res.data.data.projectMoney ? res.data.data.projectMoney  : '',
                          AcademicExpenses:  res.data.data.classMoney ? res.data.data.classMoney  : '',
                          AcademicClasses:  res.data.data.classHour ? res.data.data.classHour  : '',
                          FamilyEducationClass:  res.data.data.familyHour ? res.data.data.familyHour  : '',
                          FamilyEducationExpenses:  res.data.data.familyMoney ? res.data.data.familyMoney  : '',
                          AccompanyingReadingFee:  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : '',
                          AccompanyingReading:  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : '',
                          RemoteRoadRepair:  res.data.data.wayMoney ? res.data.data.wayMoney  : '',
                          PaymentTime:  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : '',
                          Paymentchannel:  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                          classGiveHour:  res.data.data.classGiveHour ? res.data.data.classGiveHour  : '',
                          familyGiveHour:  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : '',
                          readingGiveHour:  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : '',
                          diagnoseMoney:  res.data.data.diagnoseMoney,
                          diagnoseHour:  res.data.data.diagnoseHour,
                          diagnoseGiveHour:  res.data.data.diagnoseGiveHour,
                          studentMoney:  res.data.data.studentMoney,
                          studentHour:  res.data.data.studentHour,
                          studentGiveHour:  res.data.data.studentGiveHour,
                          patriarchMoney:  res.data.data.patriarchMoney,
                          patriarchHour:  res.data.data.patriarchHour,
                          patriarchGiveHour:  res.data.data.patriarchGiveHour,
                          chargeCollectionPicture:  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],

                          periodsNumber: res.data.data.periodsNumber,
                          PaymentTime: res.data.data.chargeCollectionDate,
                          Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                          renewCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],

                          

                      }  

                   )


                    

                    console.log(this.renewalCollectionList, '222222222222222222222222222222')
          }

                


          // (3) 是否退费
          this.isThereARefund = res.data.data.isReturnPremium === 0 ? '' : res.data.data.isReturnPremium

          // =========================================================(退费)=======================================================
          this.isWantToContinueTheClass = res.data.data.isContinueType



          if(this.typeCustomerFunding === '退费'){
              this.isCustomerStatus = res.data.data.customerReturnType
          }

          if(this.costType === 4 && res.data.data.categoryType === 1){


            // res.data.data = JSON.parse(res.data.data)

            console.log(res.data.data, '0000000000000000000000000000000000000000=========》》》》》》》》》')
          
            this.AcademicExpenses = res.data.data.returnPremiumPrice ? res.data.data.returnPremiumPrice : ''
            this.PaymentTime = res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
            this.Paymentchannel = res.data.data.returnPremiumPayType ? res.data.data.returnPremiumPayType : ''
            this.AcademicClasses = res.data.data.returnPremiumHour ? res.data.data.returnPremiumHour : ''


            this.Plan = res.data.data.classHour
            this.FamilyEducationExpenses = res.data.data.familyMoney
            this.FamilyEducationClass = res.data.data.familyHourRenew
            this.AccompanyingReadingFee = res.data.data.readingPartnerMoney
            this.AccompanyingReading = res.data.data.readingPartnerHour
            this.classGiveHour = res.data.data.classGiveHour
            this.familyGiveHour = res.data.data.familyGiveHour
            this.readingGiveHour = res.data.data.readingGiveHour
            this.studentMoney = res.data.data.studentMoney
            this.diagnoseMoney = res.data.data.diagnoseMoney
            this.diagnoseHour = res.data.data.diagnoseHour
            this.diagnoseGiveHour = res.data.data.diagnoseGiveHour
            this.studentHour = res.data.data.studentHour
            this.studentGiveHour  = res.data.data.studentGiveHour
            this.patriarchMoney = res.data.data.patriarchMoney
            this.patriarchHour  = res.data.data.patriarchHour
            this.patriarchGiveHour = res.data.data.patriarchGiveHour
            this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
            this.periodsNumber = res.data.data.periodsNumber

            this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
            this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
            this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
        
            this.Plan =  res.data.data.projectMoney ? res.data.data.projectMoney  : ''
            this.AcademicExpenses =  res.data.data.classMoney ? res.data.data.classMoney  : '' 
            this.AcademicClasses =  res.data.data.classHour ? res.data.data.classHour  : ''
            this.FamilyEducationClass =  res.data.data.familyHour ? res.data.data.familyHour  : ''
            this.FamilyEducationExpenses =  res.data.data.familyMoney ? res.data.data.familyMoney  : ''
            this.AccompanyingReadingFee =  res.data.data.readingPartnerMoney ? res.data.data.readingPartnerMoney  : ''
            this.AccompanyingReading =  res.data.data.readingPartnerHour ? res.data.data.readingPartnerHour  : ''
            this.RemoteRoadRepair =  res.data.data.wayMoney ? res.data.data.wayMoney  : ''
            this.PaymentTime =  res.data.data.customerAllpaytime ? res.data.data.customerAllpaytime  : ''
            this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
            this.classGiveHour =  res.data.data.classGiveHour ? res.data.data.classGiveHour  : ''
            this.familyGiveHour =  res.data.data.familyGiveHour ? res.data.data.familyGiveHour  : ''
            this.readingGiveHour =  res.data.data.readingGiveHour ? res.data.data.readingGiveHour  : ''
            this.diagnoseMoney =  res.data.data.diagnoseMoney
            this.diagnoseHour =  res.data.data.diagnoseHour
            this.diagnoseGiveHour =  res.data.data.diagnoseGiveHour
            this.studentMoney =  res.data.data.studentMoney
            this.studentHour =  res.data.data.studentHour
            this.studentGiveHour =  res.data.data.studentGiveHour
            this.patriarchMoney =  res.data.data.patriarchMoney
            this.patriarchHour =  res.data.data.patriarchHour
            this.patriarchGiveHour =  res.data.data.patriarchGiveHour
            this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
            this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
            this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
            this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
            
            if(res.data.data.wayMoney){
              this.RemoteRoadRepair = res.data.data.wayMoney
            }
          } 



          if( res.data.data.costType === 1 && res.data.data.categoryType === 2){
                 this.isTypeLve = res.data.data.categoryType === 2 ? 2 : 1
                 
                 if(this.isTypeLve === 2){

                    this.happyMoney = res.data.data.happyMoney
                    this.happyHour = res.data.data.happyHour
                    this.happyGiveHour = res.data.data.happyGiveHour
                    this.parentAwarenessMoney = res.data.data.parentAwarenessMoney
                    this.parentAwarenessHour = res.data.data.parentAwarenessHour
                    this.parentAwarenessGiveHour = res.data.data.parentAwarenessGiveHour
                    this.familyProblemMoney = res.data.data.familyProblemMoney
                    this.familyProblemHour = res.data.data.familyProblemHour
                    this.familyProblemGiveHour = res.data.data.familyProblemGiveHour
                    this.patriarchReplayMoney = res.data.data.patriarchReplayMoney
                    this.patriarchReplayHour = res.data.data.patriarchReplayHour
                    this.patriarchReplayGiveHour = res.data.data.patriarchReplayGiveHour
                    this.childReplayMoney = res.data.data.childReplayMoney
                    this.childReplayHour = res.data.data.childReplayHour
                    this.childReplayGiveHour = res.data.data.childReplayGiveHour
                    this.educationPerceiveMoney = res.data.data.educationPerceiveMoney
                    this.educationPerceiveHour = res.data.data.educationPerceiveHour
                    this.educationPerceiveGiveHour = res.data.data.educationPerceiveGiveHour
                    this.fenCaseMoney = res.data.data.fenCaseMoney
                    this.fenCaseHour = res.data.data.fenCaseHour
                    this.fenCaseGiveHour = res.data.data.fenCaseGiveHour

                    this.PaymentTime = res.data.data.chargeCollectionDate
                    this.Paymentchannel = Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                    this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                    this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []


                    this.affinityBookMoney = res.data.data.affinityBookMoney
                    this.affinityBookHour = res.data.data.affinityBookHour
                    this.affinityBookGiveHour = res.data.data.affinityBookGiveHour

                 }
            }


            if(res.data.data.costType === 2 && res.data.data.categoryType === 2){
                 this.isTypeLve = res.data.data.categoryType === 2 ? 2 : 1
                 
                 if(this.isTypeLve === 2){

                    this.renewalCollectionListWay = []
                    this.renewalCollectionListWay.push({
                          happyMoney: res.data.data.happyMoney,
                          happyHour: res.data.data.happyHour,
                          happyGiveHour: res.data.data.happyGiveHour,
                          parentAwarenessMoney: res.data.data.parentAwarenessMoney,
                          parentAwarenessHour: res.data.data.parentAwarenessHour,
                          parentAwarenessGiveHour: res.data.data.parentAwarenessGiveHour,
                          familyProblemMoney: res.data.data.familyProblemMoney,
                          familyProblemHour: res.data.data.familyProblemHour,
                          familyProblemGiveHour: res.data.data.familyProblemGiveHour,
                          patriarchReplayMoney: res.data.data.patriarchReplayMoney,
                          patriarchReplayHour: res.data.data.patriarchReplayHour,
                          patriarchReplayGiveHour: res.data.data.patriarchReplayGiveHour,
                          childReplayMoney: res.data.data.childReplayMoney,
                          childReplayHour: res.data.data.childReplayHour,
                          childReplayGiveHour: res.data.data.childReplayGiveHour,
                          educationPerceiveMoney: res.data.data.educationPerceiveMoney,
                          educationPerceiveHour: res.data.data.educationPerceiveHour,
                          educationPerceiveGiveHour: res.data.data.educationPerceiveGiveHour,
                          fenCaseMoney: res.data.data.fenCaseMoney,
                          fenCaseHour: res.data.data.fenCaseHour,
                          fenCaseGiveHour: res.data.data.fenCaseGiveHour,

                          PaymentTime: res.data.data.chargeCollectionDate,
                          Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                          chargeCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                          doubtContent: res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : [],


                          affinityBookMoney: res.data.data.affinityBookMoney,
                          affinityBookHour: res.data.data.affinityBookHour,
                          affinityBookGiveHour: res.data.data.affinityBookGiveHour,
                    })
                 }
            }


            if( res.data.data.costType === 3 && res.data.data.categoryType === 2){
                this.isTypeLves = res.data.data.categoryType === 2 ? 2 : 1
                if(this.isTypeLves === 2){

                    this.renewalCollectionList = []
                    this.renewalCollectionList.push({
                          happyMoney: res.data.data.happyMoney,
                          happyHour: res.data.data.happyHour,
                          happyGiveHour: res.data.data.happyGiveHour,
                          parentAwarenessMoney: res.data.data.parentAwarenessMoney,
                          parentAwarenessHour: res.data.data.parentAwarenessHour,
                          parentAwarenessGiveHour: res.data.data.parentAwarenessGiveHour,
                          familyProblemMoney: res.data.data.familyProblemMoney,
                          familyProblemHour: res.data.data.familyProblemHour,
                          familyProblemGiveHour: res.data.data.familyProblemGiveHour,
                          patriarchReplayMoney: res.data.data.patriarchReplayMoney,
                          patriarchReplayHour: res.data.data.patriarchReplayHour,
                          patriarchReplayGiveHour: res.data.data.patriarchReplayGiveHour,
                          childReplayMoney: res.data.data.childReplayMoney,
                          childReplayHour: res.data.data.childReplayHour,
                          childReplayGiveHour: res.data.data.childReplayGiveHour,
                          educationPerceiveMoney: res.data.data.educationPerceiveMoney,
                          educationPerceiveHour: res.data.data.educationPerceiveHour,
                          educationPerceiveGiveHour: res.data.data.educationPerceiveGiveHour,
                          fenCaseMoney: res.data.data.fenCaseMoney,
                          fenCaseHour: res.data.data.fenCaseHour,
                          fenCaseGiveHour: res.data.data.fenCaseGiveHour,

                          PaymentTime: res.data.data.chargeCollectionDate,
                          Paymentchannel: Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : '',
                          renewCollectionPicture: res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : [],
                          doubtContent: res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : [],

                          affinityBookMoney: res.data.data.affinityBookMoney,
                          affinityBookHour: res.data.data.affinityBookHour,
                          affinityBookGiveHour: res.data.data.affinityBookGiveHour,
                    })
                 }
            }


            if( res.data.data.costType === 4 && res.data.data.categoryType === 2){
                this.isTypeLvess = res.data.data.categoryType === 2 ? 2 : 1

                this.happyMoney = res.data.data.happyMoney
                this.happyHour = res.data.data.happyHour
                this.happyGiveHour = res.data.data.happyGiveHour
                this.parentAwarenessMoney = res.data.data.parentAwarenessMoney
                this.parentAwarenessHour = res.data.data.parentAwarenessHour
                this.parentAwarenessGiveHour = res.data.data.parentAwarenessGiveHour
                this.familyProblemMoney = res.data.data.familyProblemMoney
                this.familyProblemHour = res.data.data.familyProblemHour
                this.familyProblemGiveHour = res.data.data.familyProblemGiveHour
                this.patriarchReplayMoney = res.data.data.patriarchReplayMoney
                this.patriarchReplayHour = res.data.data.patriarchReplayHour
                this.patriarchReplayGiveHour = res.data.data.patriarchReplayGiveHour
                this.childReplayMoney = res.data.data.childReplayMoney
                this.childReplayHour = res.data.data.childReplayHour
                this.childReplayGiveHour = res.data.data.childReplayGiveHour
                this.educationPerceiveMoney = res.data.data.educationPerceiveMoney
                this.educationPerceiveHour = res.data.data.educationPerceiveHour
                this.educationPerceiveGiveHour = res.data.data.educationPerceiveGiveHour
                this.fenCaseMoney = res.data.data.fenCaseMoney
                this.fenCaseHour = res.data.data.fenCaseHour
                this.fenCaseGiveHour = res.data.data.fenCaseGiveHour 
                this.PaymentTime = res.data.data.paymentTime
                this.Paymentchannel = res.data.data.paymentChannel
                this.chargeCollectionPicture = res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                this.doubtContent = res.data.data.commitRemark ? JSON.parse(res.data.data.commitRemark) : []

                this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []
                this.PaymentTime =  res.data.data.chargeCollectionDate ? res.data.data.chargeCollectionDate : ''
                this.Paymentchannel =  Number(res.data.data.payAlltype) ? Number(res.data.data.payAlltype)  : ''
                this.chargeCollectionPicture =  res.data.data.chargeCollectionPicture ? JSON.parse(res.data.data.chargeCollectionPicture) : []

                this.affinityBookMoney = res.data.data.affinityBookMoney
                this.affinityBookHour = res.data.data.affinityBookHour
                this.affinityBookGiveHour = res.data.data.affinityBookGiveHour

            }







          } else {
            this.$message({  message: res.data.message,   type: "error"  });
          }
        });
    },

    closeEditDialogReject(){
      // this.showEdit = false
      this.rejectDialogShow = true
      // this.$nextTick(() => {
      //     this.$refs.rejectDialogComponents.init(this.customerId)
      // })
    },

    closeEditDialogSubt(){
      // orderCustomerAudit/audit
      let urls = this.fileAllLists.length > 0 ? this.fileAllLists[0].url : ''
      axios.post(`${ apiBaseUrl }/customerInformationCollectionAudit/audit`, { 
        uploadingPicture: urls , 
        auditStatus: 2, 
        id: this.order.id, 
        rejectCause: this.order.rejectCause, 
        commitRemark: '' ,
        chargeCollectionDate: this.PaymentTime, 
        chargeCollectionPicture: JSON.stringify(this.chargeCollectionPicture), 
        payAlltype: this.Paymentchannel, 

      }, {headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
        if (res.data.code === 200) {
              this.$message({  message: res.data.message,  type: "success"  });
              this.showEdit = false
              this.$emit('handleEventColes', false)
          }else{
            this.$message({  message: res.data.message,  type: "error"  });
          }
      })
    },

    handleEventBus(e){
      this.rejectDialogShow = e
      this.showEdit = true
    },

    handleEventBusSbut(e){
      this.rejectDialogShow = e
      this.showEdit = e
    },

    init (customerId) {
      this.customerId = customerId;
      this.showEdit = true;


      axios.get(`${apiBaseUrl}/customerinformation/getOne/${customerId}`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}) .then(res => {
          if (res.data.code === 200) {
            this.order.classHour = res.data.data.classHour
            this.order.familyHour = res.data.data.familyHour

            this.order.orderStatus = res.data.data.orderStatus
            this.order.teacherIdOnline = res.data.data.onlineTeacherName
            this.order.teacherIdOffline = res.data.data.offlineTeacherName
            if (res.data.data.onlineTime !== null) {
              this.order.onlineTime = JSON.parse(res.data.data.onlineTime)
            }
            if (res.data.data.offlineTime !== null) {
              this.order.offlineTime = JSON.parse(res.data.data.offlineTime)
            }
            this.order.customerIspay = res.data.data.customerIspay + "";
            this.order.isRenew = res.data.data.isRenew
            this.order.customerIsallpay =
              res.data.data.customerIsallpay + "";
            this.order.customerAllpaymoney =
              res.data.data.customerAllpaymoney;
            this.order.customerAllpaytime =
              res.data.data.customerAllpaytime;
            this.order.onlineStatus = res.data.data.onlineStatus
            this.order.offlineStatus = res.data.data.offlineStatus
            this.order.remarks = res.data.data.remarks
            this.order.parentPhoneNumber = res.data.data.parentPhoneNumber;
            this.order.gradeIdArrToStr = res.data.data.gradeIdArrToStr;
            this.order.teacherName = res.data.data.userName;
            this.order.classType = res.data.data.classType;
            this.order.categoryIdArrToStr =
              res.data.data.categoryIdArrToStr;
            this.order.studentName = res.data.data.customerStudent;
            this.order.sex = res.data.data.sex;
            this.order.grade = res.data.data.gradeIdArr2;
            this.order.courseCategoryId = res.data.data.categoryIdArr2;
            this.order.address = res.data.data.address;
            this.order.customerPaytime = res.data.data.customerPaytime;
            this.order.teacherId = res.data.data.customerTeacherid;
            // this.order.startTime = JSON.parse(res.data.data.startTime);
            // this.order.startTimeDay = this.order.startTime[0];
            // this.order.startTimeHour = this.order.startTime[1];

            this.order.customerPaymoney = res.data.data.customerPaymoney;

            

            this.order.payType = res.data.data.payType;
            this.order.payType2 = res.data.data.payType2;
            this.order.payAllType2 = res.data.data.payAllType2;

            this.order.payAlltype = res.data.data.payAlltype;
            this.order.stages = res.data.data.stages ? JSON.parse(res.data.data.stages) : []
            this.order.renew = res.data.data.renew ?  JSON.parse(res.data.data.renew) : []






            
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
    },
    isFull () {
        this.order.stages = [  { stagesMoney: "",  stagesDate: "",   payType: ""  } ];
    },
    isNo () {
        this.order.customerAllpaymoney = "";
        this.order.customerAllpaytime = "";
        this.order.payAlltype = "";
    },

    addInput () {
      this.order.stages.push({  stagesMoney: "",  stagesDate: "",   payType: ""   });
    },

    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },
    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
    },
    closeEditDialog () {
      this.showEdit = false;
      this.order.onlineTime = []
      this.order.offlineTime = []
      this.$emit('handleEventColes', false)

    },

    toDiagnosis () {
      if(this.orderFormComponentsID){
          this.$router.push({  path: "/diagnosisdetail",   query: {  customerId: this.orderFormComponentsID  }   });
      }else{
          this.$message({ message: "当前数据没有customerId", type: "warning" });
      }
    },
    getGrade () {
      axios.get(`${apiBaseUrl}/grade/getGrade`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.order.gradeList = res.data.data;
        }).catch(error => { this.$message({ message: "获取年级列表失败", type: "error" })});
    },

    getTeachers () {
      axios.get(`${apiBaseUrl}/schedule/teacherlist`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}})  .then(res => { this.teachers = res.data.data;  }) .catch(error => {  this.$message({  message: "获取老师列表失败",  type: "error"  });  });
    },

    getCategoryList () {
      axios.get(`${apiBaseUrl}/schedule/categorylist`,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.categoryList = res.data.data;
        }).catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },
    saveEditForm () {
      this.$refs["order"].validate(valid => {
        if (valid) {
          axios.post(`${apiBaseUrl}/teachStuInfo/save`, this.order, {headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
              if (res.data.code === 200) {
                this.showEdit = false;
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            });
        }
      });
    }
  },
  beforeCreate () { },

  created () {

  },

  beforeMount () { },

  mounted () {
    
      this.payTypes = JSON.parse(sessionStorage.getItem('payTypesList'))

      this.fileAllLists = [{ url: this.uploadingPicture ?  this.uploadingPicture : '' }]

      this.getGrade();
      this.getTeachers();
      this.getCategoryList();

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
      })

      axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
        this.optionList2 = res.data.data
      })
  },

  beforeUpdate () { },

  updated () { },

  beforeDestroy () { },
  destroyed () { },

  activated () { }
};
</script>

<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #cc>>>.el-dialog {
    width: 50%;
  }
}
.inputcolor > .el-input__inner{
  color: red !important;
}

.init-b{
    text-align: start;
    padding-left: 10px;
    height: 169px;
    overflow-y: auto;
    border: 1px solid #dcd5d5;
    border-radius: 2px;
    padding-top: 10px;
    margin-left: 10px;
}

.inputcolor > .el-input__inner{
  color: red !important;
}

.no-click{
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/OrderDetail.vue